// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper_3v5Wc","loaderText":"Loader_loaderText_DN8rr"};